// src/pages/BlogPost1.jsx
import React from "react";
import Navbar from "../../components/navbar";
import Footer from "../../components/Footer";
import "./blogpost.css"; // keep your styling!

export default function BlogPost1() {
  return (
    <>
      <Navbar />
      <div className="blogpost-page medieval-root">
        <div className="blogpost-card medieval-text">
          <h1 className="blogpost-title">What it was like developing this app (new to react/django)</h1>
          <span className="blogpost-date">July 26, 2025</span>
          <div className="blogpost-content">
            <p>
First lesson: keep your frontend and backend folders apart unless you enjoy chaos. Also, don’t waste time making a website before you make the app—learned that the hard way. Inline styles? Never again. Thanks to DevTools’ dimension switcher (which I found after multiple redesigns), mobile layouts aren’t quite as scary—just sprinkle in @media queries and pretend you tested every device. Django’s file structure is actually simple (when you finally look at it), and React is all about building components… if only someone told me to start with them. My folder structure is now only mildly cursed, and generating AI content/images is the only part that felt like cheating. Next project: faster, smarter, less painful (supposedly).
            </p>
            <p>
              p.s if you try and reset your password, good luck.  
            </p>
            <p>-Alex</p>
            {/* Add more content here */}
          </div>
          <a href="/blog" className="medieval-btn ghost" style={{marginTop: "1.7rem"}}>← Back to Blog</a>
        </div>
      </div>
      <Footer />
    </>
  );
}
